import React, { useContext, useState } from 'react'
import LanguageIcon from '@mui/icons-material/Language';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SearchIcon from '@mui/icons-material/SearchRounded';
import ArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'; 
import MenuIcon from '@mui/icons-material/Menu'; 
import AddIcon from '@mui/icons-material/Add';
import Development from '../assets/development.jpg'
import Business from '../assets/business.jpg'
import { appContext } from '../Context/appProvider';
import { Link } from 'react-router-dom';
import { settingsContext } from '../Context/settingsProvider';
import Hamburger from 'hamburger-react'
import { baseUrl, path, sellerBaseUrl } from '../constants';
import axios from 'axios';
import logo from '../assets/logo.png'
import { api } from '../api';

export default function Header(props) {
    const [hovered, setHovered] = useState(false)
    const [category, setCategory] = useState(null)
    const {token, categories, setShowSidebar, showSidebar} = useContext(appContext)
    const {setChooseLang, t} = useContext(settingsContext)
    const [results, setResults] = useState(null)
    const [searchLoading, setSearchLoading] = useState(false)
    const [cancelToken, setCancelToken] = useState(null);

    const onSearch = async value => {
        if(!value) return
           setSearchLoading(true)
           if (cancelToken) {
            cancelToken.cancel('cancelled');
          }

          const newCancelToken = axios.CancelToken.source();
          setCancelToken(newCancelToken);
  
           try {
            const response = await api.get(path.searchCourses + `?q=${value}`, {
                cancelToken: newCancelToken.token,
              });
              setSearchLoading(false)
              setResults(response.data.results)
           } catch(e){ 
                if (axios.isCancel(e)) {
                    setSearchLoading(false)
                }
            }
    }

    return (
    <div className={`flex items-center gap-10 max-md:gap-2 fixed right-0 top-0 px-12 h-[60px] z-[999999] ${props.dark ? 'bg-black' : 'bg-white'} shadow-lg left-0 ${props.simple ? 'p-2' : ''} max-md:left-0 max-md:px-2`}>
        {/* <div className='flex items-center gap-11'> */}
                {/* {props.withLogo && <Link to='/' className='bg-white p-1 rounded-md max-md:hidden'>
                <img src={logo} className='w-[40px] object-contain' />
            </Link> } */}

            <div className='flex items-center gap-2 max-md:gap-0'>
                <Hamburger toggled={showSidebar} toggle={() => setShowSidebar(s => !s)} color="#6622cf" size={25}/>
                <Link to='/' className='rounded-md'>
                    <img src={logo} className='w-[35px] object-contain' />
                </Link>
            </div>
            
            {!props.simple &&
            <div className='h-[60px] flex items-center max-md:hidden' onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
                <p className={`p-1 pl-2 pr-2 rounded-sm ${hovered ? 'text-main' : props.dark ? 'text-white' : 'text-black'} text-md`}>{t('CATEGORIES')}
                <ArrowDownIcon style={{fontSize: 22}}>Filled</ArrowDownIcon>
                </p>
            </div> }
            {hovered && (
                <div onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} style={{zIndex: 99999}}
                    className='absolute flex top-[60px] bg-white shadow-lg rounded-md z-50 w-[700px] h-[400px] '>
                        <div className='flex flex-col p-3  gap-3 flex-1'>
                            {categories?.map(category => (
                                <Link to={'/category/' + category?.name?.replace(/ /g, '-')} className='flex gap-1 items-center w-full justify-between cursor-pointer group' onMouseEnter={() => setCategory(category)}>
                                    <p className='text-black transition-all group-hover:text-main text-[16px]'>{category.name}</p>
                                    <ArrowForwardIosIcon className='group-hover:text-main' style={{fontSize: 13}}>Filled</ArrowForwardIosIcon>
                                </Link>
                            ))}
                        </div>                        
                        <div className='flex flex-1 items-start p-3'>
                            <img className='w-full h-full object-cover rounded-md' src={!category ? baseUrl + categories?.at(0)?.cover : baseUrl + category?.cover} alt='thumbnail' />
                        </div>
                        <div className='flex flex-1 flex-col gap3 p-3'>
                            {(category?.subcategories || categories?.at(0)?.subcategories)?.map(sub => (
                                    <div className='flex gap-1 items-center w-full justify-between p-2 cursor-pointer group'>
                                        <Link to={'/category/' + category?.name?.replace(/ /g, '-') + '/' + sub.name.replace(/ /g, '-')} className='text-[14px] transition-all text-black group-hover:text-main'>{sub.name}</Link>
                                    </div>
                                ))}
                        </div>
                </div>
            )}
        {/* </div> */}
        {!props.simple && <div className='flex items-center flex-1 relative'>
            <input onFocus={e => onSearch(e.target.value)} onBlur={(e) => {
                setTimeout(() => {
                    setResults(null)
                    setSearchLoading(false)
                }, 200)
            }} onKeyUp={e => onSearch(e.target.value)} type='search' placeholder={t('SEARCH_COURSES')} className='w-full placeholder:text-[#00000095] bg-white placeholder-black border-solid border-main border-[1px] outline-none text-black bg-transparent focus:border-[2px] rounded-[30px] p-2 pl-[40px]' />
            <SearchIcon style={{color: '#000000', fontSize: 18, position: 'absolute', left: 15}}>Filled</SearchIcon>
            {(searchLoading || results) && <div className='absolute top-[45px] left-0 right-0 bg-white shadow-sm p-1 z-50'>
                {searchLoading ? new Array(1).fill(0).map(a =>
                    <div className='flex item-center gap-5 p-2'>
                        <div className='w-[60px] h-[60px] bg-[#acacac] animate-pulse'></div>
                        <div className='flex flex-col gap-1'>
                            <div className='w-[120px] h-[20px] bg-[#acacac] animate-pulse'></div>
                            <div className='w-[80px] h-[15px] bg-[#acacac] animate-pulse'></div>
                        </div>
                    </div>
                )
                : !results?.length ?
                    <p className='text-[#00000095] text-[14px] p-2'>{t('NO_RESULTS')}</p>
                 : results?.map(course => (
                    <Link to={'/course/' + course.id} className='flex item-center gap-5 p-2 hover:bg-[#00000030]'>
                        <img className='w-[60px] h-[60px] object-contain' src={baseUrl + course.thumbnail} alt='course' />
                        <div className='flex flex-col gap-1'>
                            <h4 className='text-black font-bold'>{course.title.slice(0, 60)}</h4>
                            <p className='text-[#00000080] text-[13px]'>{t('COURSE_BY')} <b>{course.instructor.firstName}</b></p>
                        </div>
                    </Link>
                 ))
                }
            </div> }
        </div> }
        {/* <div className='flex items-center gap-8'> */}
                <a className='text-white text-sm font-bold hover:text-black flex items-center gap-2 group' href={sellerBaseUrl} target="_blank">
                    <button className='w-[25px] h-[25px] rounded-full bg-main flex items-center justify-center border-none text-main group-hover:bg-black'>
                        <AddIcon style={{ fontSize: 20, color: '#ffffff'}}>Filled</AddIcon>
                    </button>
                    <p className={`max-md:hidden ${(!props.dark && hovered) ? 'text-main' : 'text-black'}`}>{t('SELL_COURSE')}</p>
                </a>
                {/* <a className='text-white text-sm font-bold hover:text-black' href='http://localhost:3001' rel='noreferrer' target='_blank'>Mella Proffessionals</a> */}
            <div className='flex items-center gap-5 max-md:hidden'>
                {!token ? [
                    <Link to='/signup' className='p-1 pl-2 pr-2 rounded-sm bg-main text-white no-underline text-sm font-bold'>{t('SIGNUP')}</Link>,
                    <Link to='/login' className='p-1 pl-2 pr-2 rounded-sm border-solid border-[1px] border-main text-black text-sm font-bold no-underline'>{t('LOGIN')}</Link>
                ] : [
                    <Link to='/profile' className='bg-main w-[25px] h-[25px] rounded-full flex items-center justify-center'>
                        <AccountCircleIcon style={{fontSize: 25, color: '#ffffff'}}>Filled</AccountCircleIcon>
                    </Link>,
                    
                ]}
                {/* <button className='outline-none border-none bg-none' onClick={() => setChooseLang(true)}>
                    <LanguageIcon style={{color: 'white', fontSize: 25}}>Filled</LanguageIcon>
                </button> */}
            </div>

        {/* </div> */}
    </div>
    )
}
